import { useGridApiRef } from "@mui/x-data-grid-pro";
import { createContext, useContext, useMemo, useReducer } from "react";
import { initialCommonFilterState } from "utils/CommonFilter";

const initialState = {
  commonFilter: initialCommonFilterState,
  currentUser: {},
};

const reducer = (state, action) => {
  switch (action.type) {
    case "FILTER":
      return { ...state, commonFilter: action.data };
    case "CURRENT_USER":
      return { ...state, currentUser: action.data };
    default:
      return { ...state };
  }
};

const AppContext = createContext(undefined);

const AppContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const apiRef = useGridApiRef();

  const value = useMemo(
    () => ({ state, dispatch, apiRef }),
    [state, dispatch, apiRef]
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within an AppContextProvider");
  }
  return context;
};

export { AppContextProvider, useAppContext };
